import React from 'react';

import Breeder from './components/Breeder';
import Trainer from './components/Trainer';
import Owner from './components/Owner';
import Age from './components/Age';
import Sire from './components/Sire';
import Dam from './components/Dam';
import DamSire from './components/DamSire';

const DamDetails = props => (
    <div className="hp-details__data">
        <div className="hp-details__section">
            <Age key="Age" {...props} />
            <Sire key="Sire" {...props} />
            <Dam key="Dam" {...props} />
            <DamSire key="DamSire" {...props} />
        </div>
        <div className="hp-details__section">
            <Breeder key="Breeder" {...props} />
            <div className="hp-details__extraData">
                <Trainer key="Trainer" {...props} hasPedigree />
                <Owner key="Owner" {...props} hasPedigree />
            </div>
        </div>
    </div>
);

export default DamDetails;



// WEBPACK FOOTER //
// ./src/js/horse/details/DamDetails.jsx